import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgHandCoinsDuotone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1.75 16.625h3.5v6.125h-3.5a.875.875 0 0 1-.875-.875V17.5a.875.875 0 0 1 .875-.875Zm20.563-10.5A3.07 3.07 0 0 0 21 6.421a3.063 3.063 0 1 0-1.75 2.908 3.062 3.062 0 1 0 3.063-3.204Z"
      opacity={0.2}
    />
    <path d="M25.192 15.428a2.673 2.673 0 0 0-2.323-.462l-4.576 1.052a3.064 3.064 0 0 0-2.98-3.768H9.837a3.48 3.48 0 0 0-2.475 1.025L4.888 15.75H1.75A1.75 1.75 0 0 0 0 17.5v4.375a1.75 1.75 0 0 0 1.75 1.75h11.375a.873.873 0 0 0 .212-.026l7-1.75a.763.763 0 0 0 .13-.044l4.252-1.81.048-.02a2.69 2.69 0 0 0 .43-4.547h-.005ZM1.75 17.5h2.625v4.375H1.75V17.5Zm22.25.898-4.156 1.77-6.828 1.707H6.125v-4.888L8.6 14.513A1.735 1.735 0 0 1 9.837 14h5.476a1.313 1.313 0 0 1 0 2.625H12.25a.875.875 0 1 0 0 1.75h3.5a.908.908 0 0 0 .196-.022l7.328-1.685.034-.01a.94.94 0 0 1 .689 1.74H24ZM17.937 10.5c.217 0 .432-.017.646-.053a3.937 3.937 0 1 0 3.086-5.14 3.938 3.938 0 1 0-3.732 5.193ZM24.5 9.187a2.187 2.187 0 1 1-4.374 0 2.187 2.187 0 0 1 4.374 0Zm-6.563-4.812a2.188 2.188 0 0 1 2.106 1.598 3.937 3.937 0 0 0-1.64 2.727 2.187 2.187 0 1 1-.465-4.325Z" />
  </svg>
);
export default SvgHandCoinsDuotone;
